import CurrentEquipmentPage from "./CurrentEquipmentPage";

export default CurrentEquipmentPage;
